<div class="analysis-modal" *ngIf="analysisData" role="dialog" aria-modal="true">
  <div class="analysis-modal__backdrop" (click)="close.emit()"></div>
  <div class="analysis-modal__content">
    <header class="analysis-modal__header">
      <div>
        <h3>{{ isSchemaOutput() ? analysisInstrument() : 'Analyse-Gegenüberstellung' }}</h3>
        <p *ngIf="isSchemaOutput()">{{ headerDescription() }}</p>
        <p *ngIf="isSchemaOutput()">{{ riskDescription() }}</p>
        <p *ngIf="!isSchemaOutput()">{{ analysisInstrument() }} - Analysedatum {{ analysisDate() }}</p>
      </div>
      <button type="button" class="secondary icon" (click)="close.emit()">x</button>
    </header>

    <ng-container *ngIf="isSchemaOutput(); else legacyAnalysis">
      <section class="analysis-bias analysis-bias--warning" *ngIf="screenshotWarnings().length">
        <div class="analysis-bias__main">
          <span>Screenshot / Daten</span>
          <strong>{{ analysisData.screenshot_quality?.is_sufficient === false ? 'Warnung' : 'Hinweis' }}</strong>
        </div>
        <ul>
          <li *ngFor="let warning of screenshotWarnings()">{{ warning }}</li>
        </ul>
      </section>

      <section class="analysis-bias analysis-bias--warning" *ngIf="hasSchemaWarning()">
        <div class="analysis-bias__main">
          <span>Validierung</span>
          <strong>Pruefen</strong>
        </div>
        <ul>
          <li *ngFor="let warning of schemaValidationWarnings()">{{ warning }}</li>
        </ul>
      </section>

      <section class="analysis-overview">
        <div>
          <span>Einschaetzung</span>
          <strong>{{ biasLabel(analysisData.overall_assessment?.primary_bias) }}</strong>
        </div>
        <div>
          <span>Konfidenz</span>
          <strong>{{ analysisData.overall_assessment?.confidence_percent ?? '-' }}%</strong>
        </div>
        <div>
          <span>Aktion</span>
          <strong>{{ actionLabel(analysisData.final_recommendation?.action) }}</strong>
        </div>
        <p>{{ analysisData.overall_assessment?.summary }}</p>
        <p>{{ analysisData.final_recommendation?.reason }}</p>
      </section>

      <section class="analysis-bias analysis-bias--questions" *ngIf="analysisData.questions_if_needed?.length">
        <div class="analysis-bias__main">
          <span>Mehr Informationen noetig</span>
          <strong>{{ analysisData.questions_if_needed?.length }}</strong>
        </div>
        <ul>
          <li *ngFor="let question of analysisData.questions_if_needed">{{ question }}</li>
        </ul>
      </section>
    </ng-container>

    <ng-template #legacyAnalysis>
      <section class="analysis-status" *ngIf="analysisData.analyseStatus || analysisData.bildValidierung">
        <div>
          <span>Analyse Status</span>
          <strong>{{ analysisData.analyseStatus || 'aktiv' }}</strong>
        </div>
        <div *ngFor="let item of objectEntries(analysisData.bildValidierung)">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
        </div>
      </section>

      <section class="analysis-bias" *ngIf="analysisData.bias">
        <div class="analysis-bias__main">
          <span>Bias</span>
          <strong>{{ analysisData.bias.richtung }} - {{ analysisData.bias.staerke }}%</strong>
        </div>
        <div class="analysis-bias__timeframes">
          <span>Daily {{ analysisData.bias.daily }}</span>
          <span>H4 {{ analysisData.bias.h4 }}</span>
          <span>H1 {{ analysisData.bias.h1 }}</span>
        </div>
        <p>{{ analysisData.bias.beschreibung }}</p>
      </section>

      <section class="analysis-section" *ngIf="analysisData.extrahierteDaten">
        <header>
          <h4>Extrahierte Daten</h4>
          <span>Direkt aus dem Bild gelesene Werte.</span>
        </header>
        <div class="analysis-validation">
          <div *ngFor="let item of extractedDataEntries()">
            <span>{{ item.label }}</span>
            <strong>{{ item.value }}</strong>
          </div>
        </div>
      </section>

      <section class="analysis-section" *ngIf="analysisData.bildQualitaet">
        <header>
          <h4>Bildqualitaet</h4>
          <span>Lesbarkeit und Confidence der Analyse.</span>
        </header>
        <div class="analysis-validation">
          <div *ngFor="let item of imageQualityEntries()">
            <span>{{ item.label }}</span>
            <strong>{{ item.value }}</strong>
          </div>
        </div>
      </section>

      <section class="analysis-summary" *ngIf="analysisData.basisAnalyse">
        <div>
          <span>Marktstruktur</span>
          <p>{{ analysisData.basisAnalyse.marktstruktur }}</p>
        </div>
        <div>
          <span>Volume Profile</span>
          <p>{{ analysisData.basisAnalyse.volumeProfile }}</p>
        </div>
        <div>
          <span>Liquiditaet</span>
          <p>{{ analysisData.basisAnalyse.liquiditaet }}</p>
        </div>
        <div>
          <span>Footprint</span>
          <p>{{ analysisData.basisAnalyse.footprint }}</p>
        </div>
        <div>
          <span>Wichtige Zonen</span>
          <p>{{ analysisData.basisAnalyse.wichtigeZonen?.join(', ') }}</p>
        </div>
      </section>

      <section class="analysis-validation" *ngIf="analysisData.checkliste">
        <div *ngFor="let item of analysisChecklistEntries()">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
        </div>
      </section>

      <section class="analysis-validation" *ngIf="analysisData.validierung">
        <div *ngFor="let item of analysisValidationEntries()">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
        </div>
      </section>

      <section class="analysis-validation" *ngIf="analysisData.emaAnalyse || analysisData.emaBewertung">
        <div *ngFor="let item of analysisEmaEntries()">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
        </div>
      </section>

      <section class="analysis-section" *ngIf="analysisData.marktstruktur">
        <header>
          <h4>Marktstruktur</h4>
        </header>
        <div class="analysis-validation">
          <div *ngFor="let item of marketStructureEntries()">
            <span>{{ item.label }}</span>
            <strong>{{ item.value }}</strong>
          </div>
        </div>
      </section>

      <section class="analysis-section" *ngIf="analysisData.volumeProfileBewertung">
        <header>
          <h4>Volume Profile</h4>
        </header>
        <div class="analysis-validation">
          <div *ngFor="let item of volumeProfileEntries()">
            <span>{{ item.label }}</span>
            <strong>{{ item.value }}</strong>
          </div>
        </div>
      </section>

      <section class="analysis-section" *ngIf="analysisData.footprintValidierung">
        <header>
          <h4>Footprint-Validierung</h4>
        </header>
        <div class="analysis-validation">
          <div *ngFor="let item of footprintValidationEntries()">
            <span>{{ item.label }}</span>
            <strong>{{ item.value }}</strong>
          </div>
        </div>
      </section>

      <section class="analysis-bias analysis-bias--warning" *ngIf="analysisDataGapText()">
        <div class="analysis-bias__main">
          <span>Datenluecken</span>
          <strong>Hinweis</strong>
        </div>
        <p>{{ analysisDataGapText() }}</p>
      </section>

      <section class="analysis-candidates" *ngIf="analysisData.szenarioKandidaten?.length">
        <header>
          <h4>Szenario-Kandidaten</h4>
          <span>Vorbewertung aus der Analyse</span>
        </header>
        <div class="analysis-candidate-grid">
          <article
            class="analysis-candidate"
            *ngFor="let candidate of analysisData.szenarioKandidaten"
            [class.analysis-candidate--selected]="candidate.auswahl === 'Top 3'"
          >
            <div>
              <strong>{{ candidate.name }}</strong>
              <span>{{ candidate.szenario }} - {{ analysisCandidateDirection(candidate) }} - {{ candidate.auswahl }}</span>
            </div>
            <div class="analysis-candidate__score">{{ candidate.gesamtScore }}</div>
          </article>
        </div>
      </section>
    </ng-template>

    <section class="analysis-variants">
      <article
        class="analysis-card"
        *ngFor="let variant of displayVariants()"
        [ngClass]="[variantStatusClass(variant), isRecommendedVariant(variant) ? 'analysis-card--recommended' : '']"
      >
        <div class="analysis-card__top">
          <div>
            <div class="analysis-card__name">{{ variantTitle(variant) }}</div>
            <div class="analysis-card__scenario" *ngIf="isSchemaOutput()">
              {{ setupTypeLabel(variant.setup_type) }} - {{ directionLabel(variant.direction) }} - {{ statusLabel(variant.status) }}
            </div>
            <div class="analysis-card__scenario" *ngIf="!isSchemaOutput()">{{ variant.szenario }} - {{ analysisDirection(variant) }}</div>
            <div class="analysis-card__scenario" *ngIf="variant.statusDerVariante">Status: {{ variant.statusDerVariante }}</div>
          </div>
          <div class="analysis-card__probability">{{ variant.probability_percent ?? variant.wahrscheinlichkeit }}%</div>
        </div>

        <div class="analysis-trade-empty" *ngIf="isSchemaOutput() && !hasTradePlan(variant)">
          Kein aktiver Trade-Plan
        </div>

        <div class="analysis-card__prices" *ngIf="isSchemaOutput() && hasTradePlan(variant)">
          <span>Entry <strong>{{ variant.entry }}</strong></span>
          <span>Stop Loss <strong>{{ variant.stop_loss }}</strong></span>
          <span>Take Profit <strong>{{ variant.take_profit }}</strong></span>
          <span>CRV <strong>{{ variant.risk_reward_ratio ?? '-' }}</strong></span>
          <span>Positionsgroesse <strong>{{ variant.position_size?.quantity ?? '-' }} {{ variant.position_size?.unit }}</strong></span>
          <span>Maximalverlust <strong>{{ variant.max_loss_eur ?? '-' }} EUR</strong></span>
          <span>Erwarteter Gewinn <strong>{{ variant.expected_profit_eur ?? '-' }} EUR</strong></span>
        </div>

        <div class="analysis-card__prices" *ngIf="!isSchemaOutput()">
          <span>Entry <strong>{{ variant.einstieg ?? variant.einstiegZone }}</strong></span>
          <span>Stop <strong>{{ stopValue(variant) }}</strong></span>
          <span>Ziel <strong>{{ targetValue(variant) }}</strong></span>
          <span *ngIf="extendedTargetValue(variant)">Erweitertes Ziel <strong>{{ extendedTargetValue(variant) }}</strong></span>
          <span *ngIf="variant.bereich">Bereich <strong>{{ variant.bereich }}</strong></span>
          <span *ngIf="variant.reaktionszone">Zone <strong>{{ variant.reaktionszone }}</strong></span>
        </div>

        <section
          class="analysis-condition"
          [class.analysis-condition--neutral]="variant.direction === 'none' || variant.status === 'no_trade'"
          *ngIf="isSchemaOutput() && variant.validity_conditions?.length"
        >
          <span>{{ validityTitle(variant) }}</span>
          <ul>
            <li *ngFor="let condition of variant.validity_conditions">{{ condition }}</li>
          </ul>
        </section>

        <section class="analysis-condition" *ngIf="!isSchemaOutput() && (variant.bestaetigung || variant.bestaetigungExakt)">
          <span>Was muss passieren?</span>
          <strong>{{ exactConditionText(variant) }}</strong>
        </section>

        <dl class="analysis-card__details" *ngIf="!isSchemaOutput()">
          <div *ngIf="variant.bestaetigung">
            <dt>Bestaetigung</dt>
            <dd>{{ variant.bestaetigung }}</dd>
          </div>
          <div *ngIf="variant.invalidierung">
            <dt>Invalidierung</dt>
            <dd>{{ variant.invalidierung }}</dd>
          </div>
        </dl>

        <p>{{ begruendungText(variant) }}</p>

        <details class="analysis-details" *ngIf="isSchemaOutput() && variant.invalidation?.length" open>
          <summary>Invalidierung</summary>
          <ul>
            <li *ngFor="let item of variant.invalidation">{{ item }}</li>
          </ul>
        </details>

        <details class="analysis-details" *ngIf="isSchemaOutput() && variant.risks?.length">
          <summary>Risiken anzeigen</summary>
          <ul>
            <li *ngFor="let item of variant.risks">{{ item }}</li>
          </ul>
        </details>

        <ng-container *ngIf="!isSchemaOutput()">
          <div class="analysis-validation analysis-validation--compact" *ngIf="variant.emaBewertung || variant.volumeProfileBewertung || variant.footprintBewertung">
            <div *ngIf="variant.emaBewertung">
              <span>EMA Bedingung</span>
              <strong>{{ variant.emaBewertung }}</strong>
            </div>
            <div *ngIf="variant.volumeProfileBewertung">
              <span>Volume Profile Bedingung</span>
              <strong>{{ variant.volumeProfileBewertung }}</strong>
            </div>
            <div *ngIf="variant.footprintBewertung">
              <span>Footprint Bedingung</span>
              <strong>{{ variant.footprintBewertung }}</strong>
            </div>
          </div>

          <div class="analysis-score" *ngIf="variant.bestaetigungExakt">
            <div class="analysis-card__trigger-title">Bestaetigung exakt</div>
            <div class="analysis-score__grid">
              <div *ngFor="let item of analysisExactConfirmationEntries(variant)">
                <span>{{ item.label }}</span>
                <strong>{{ item.value }}</strong>
              </div>
            </div>
          </div>

          <div class="analysis-score" *ngIf="variant.scoreDetails">
            <div class="analysis-card__trigger-title">Score Details</div>
            <div class="analysis-score__grid">
              <div *ngFor="let score of analysisScoreEntries(variant.scoreDetails)">
                <span>{{ score.label }}</span>
                <strong>{{ score.value }}</strong>
              </div>
            </div>
          </div>

          <div class="analysis-score" *ngIf="variant.emaBewertung && !variant.volumeProfileBewertung">
            <div class="analysis-card__trigger-title">EMA Bewertung</div>
            <div class="analysis-score__grid">
              <div *ngFor="let item of analysisEmaRatingEntries(variant)">
                <span>{{ item.label }}</span>
                <strong>{{ item.value }}</strong>
              </div>
            </div>
          </div>

          <div class="analysis-card__triggers" *ngIf="variant.trigger?.length">
            <div class="analysis-card__trigger-title">Trigger</div>
            <div class="analysis-trigger" *ngFor="let trigger of variant.trigger">
              <span>{{ trigger.dann }}%</span>
              <p>Wenn {{ trigger.wenn }} und {{ trigger.und }}</p>
            </div>
          </div>
        </ng-container>

        <button
          type="button"
          class="primary"
          *ngIf="showApply"
          (click)="applyVariant.emit(variant)"
        >
          Uebernehmen
        </button>
      </article>
    </section>

    <section class="analysis-section" *ngIf="isSchemaOutput() && analysisData.technical_levels">
      <header>
        <h4>Wichtige technische Level</h4>
        <span>Support, Resistance und Value-Zonen getrennt.</span>
      </header>
      <div class="analysis-levels">
        <div *ngIf="analysisData.technical_levels.support_zones?.length">
          <h5>Support</h5>
          <article *ngFor="let zone of analysisData.technical_levels.support_zones">
            <strong>{{ zoneTitle(zone) }}</strong>
            <span>{{ zoneMeta(zone) }}</span>
            <p>{{ zone.reasoning }}</p>
          </article>
        </div>
        <div *ngIf="analysisData.technical_levels.resistance_zones?.length">
          <h5>Resistance</h5>
          <article *ngFor="let zone of analysisData.technical_levels.resistance_zones">
            <strong>{{ zoneTitle(zone) }}</strong>
            <span>{{ zoneMeta(zone) }}</span>
            <p>{{ zone.reasoning }}</p>
          </article>
        </div>
        <div *ngIf="analysisData.technical_levels.value_zones?.length">
          <h5>Value-Zonen</h5>
          <article *ngFor="let zone of analysisData.technical_levels.value_zones">
            <strong>{{ zoneTitle(zone) }}</strong>
            <span>{{ zoneMeta(zone) }}</span>
            <p>{{ zone.reasoning }}</p>
          </article>
        </div>
      </div>
      <div class="analysis-validation">
        <div *ngIf="analysisData.technical_levels.nearest_upside_target_zone as zone">
          <span>Naechstes Ziel oben</span>
          <strong>{{ zoneTitle(zone) }}</strong>
        </div>
        <div *ngIf="analysisData.technical_levels.nearest_downside_target_zone as zone">
          <span>Naechstes Ziel unten</span>
          <strong>{{ zoneTitle(zone) }}</strong>
        </div>
      </div>
    </section>

    <section class="analysis-section" *ngIf="!isSchemaOutput() && analysisData.agentenFazit">
      <header>
        <h4>Agenten-Fazit</h4>
      </header>
      <div class="analysis-validation">
        <div *ngFor="let item of agentConclusionEntries()">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
        </div>
      </div>
    </section>

    <section class="analysis-disclaimer" *ngIf="isSchemaOutput() && analysisData.disclaimer">
      {{ analysisData.disclaimer }}
    </section>
  </div>
</div>
